import { getAccessToken } from "../api/apiClient";

/**
 * Decode payload (phần giữa) của 1 JWT. KHÔNG validate chữ ký — chỉ để đọc claim
 * phía client (vd dev_password). Trả null nếu token rỗng / hỏng.
 * Decode base64url an toàn UTF-8 (claim ho_ten tiếng Việt không làm vỡ JSON.parse).
 */
export const decodeJwtPayload = (token: string | null): Record<string, unknown> | null => {
    if (!token) return null;
    const part = token.split(".")[1];
    if (!part) return null;
    try {
        const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
        const json = decodeURIComponent(
            atob(b64)
                .split("")
                .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
                .join("")
        );
        return JSON.parse(json);
    } catch {
        return null;
    }
};

/**
 * Phiên hiện tại có đăng nhập bằng mật khẩu dev không (claim dev_password=true).
 * Dùng để hiện/ẩn chức năng hỗ trợ "Reset mật khẩu SV" trên Header.
 * Backend vẫn gate độc lập (claim + DevAuth.AllowPasswordReset) — đây chỉ là UX.
 */
export const isDevSession = (): boolean => {
    const payload = decodeJwtPayload(getAccessToken());
    return payload?.dev_password === "true" || payload?.dev_password === true;
};
